var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vertical-info-card',{attrs:{"items":_vm.items,"header":"Cache"}},[_c('v-btn',{staticClass:"me-3 mt-5",attrs:{"color":"primary","outlined":"","loading":_vm.isLoading},on:{"click":_vm.clearCache}},[_vm._v("Clear Cache ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }